import { clearLocalStorageExceptPersisted } from '@/utils/storage/persistedStorage';
import { auth } from '@/api/login';
import companyLogo from '@/assets/images/autologo.png';
import '@/assets/style/main.css';

import { AdminFooter, Sidebar } from '@/components';
import { useToken } from '@/hooks';
import GlobalModal from '@/utils/modal/Modal';
import { useMutateGetApi } from '@/apiError/apiShow';

import {
  ExclamationCircleFilled,
  ExclamationCircleOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  WifiOutlined,
} from '@ant-design/icons';
import {
  Alert,
  Avatar,
  Badge,
  Button,
  Carousel,
  Divider,
  Dropdown,
  Layout,
  message,
  Modal,
  Tag,
  theme,
} from 'antd';

import bell from '@/assets/images/bell.png';
import keyboard from '@/assets/images/keyboard.png';
import question from '@/assets/images/question.png';
import setting from '@/assets/images/settings.png';
import { decryptData } from '@/components/reusable/crypto/Cipher';
import ContactForSupport from '@/utils/components/ContactForSupport';
import Cookies from 'js-cookie';
import { useEffect, useRef, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import DashboardDrawer from './DashboardDrawer';
import { adminContentStyle, adminHeaderStyle } from './style';
import { useLocation } from 'react-router-dom';
import DisplayNetworkStatus from './componets/display-network-status';
import { AntButton } from '@/common/ant-components/AntButton';
import CalculatorApp from './componets/calculator-app';
import { ModalFiscalYear } from './modal-fiscal-year';
import { useSelector } from 'react-redux';
// import { userData } from '@/common/custom-date-selector-list/helpers';

const { Header, Footer, Content } = Layout;

/**
 * Decodes a Base64 string into a data URL for an image.
 * @param {string} base64Str - The Base64 string.
 * @returns {string} - The data URL for the image.
 */
const decodeBase64Image = (base64Str) => {
  return `data:image/jpeg;base64,${base64Str}`;
};

/**
 * DashboardLayout component for the admin dashboard.
 * @param {Object} props - The component props.
 * @param {React.ReactNode} props.children - The children components.
 * @returns {JSX.Element} - The rendered component.
 */

const DashboardLayout = () => {
  const navigate = useNavigate();
  const logoutButtonRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerType, setDrawerType] = useState(null);
  const [user, setUser] = useState({});
  const [login, setLogin] = useState({});
  const [daysUntilExpiry, setDaysUntilExpiry] = useState(null);
  const [shortcuts, setShortcuts] = useState(false);
  const [contactDrawerVisible, setContactDrawerVisible] = useState(false);
  const [help, setHelp] = useState(false);
  const token = useToken();
  const [fiscalYearOpen, setFiscalYearOpen] = useState(false);

  const { confirm } = Modal;

  const app = useSelector((state) => state?.financialData?.data);

  const {
    mutateAsync: mutateFinancialYear,
    data: FinancialData,
    isPending,
  } = useMutateGetApi();

  const clearAllCookies = () => {
    const allCookies = Cookies.get(); // Get all cookies
    Object.keys(allCookies).forEach((cookie) => Cookies.remove(cookie)); // Remove each cookie
  };
  const messages = [
    'This is a beta version and is under testing.',
    'If any errors arise, please contact us.',
  ];

  /**
   * Handles the logout confirmation action.
   * Clears session storage and navigates to the login page.
   */

  const tokenUnavailable = () => {
    sessionStorage.clear();
    navigate('/login');
    clearAllCookies();
    clearLocalStorageExceptPersisted();
    return;
  };

  const tokenAvailable = () => {
    auth.logout();
    setIsModalVisible(false);
    sessionStorage.clear();
    clearLocalStorageExceptPersisted();
    clearAllCookies();
  };
  const handleConfirm = async () => {
    if (!token) {
      await tokenUnavailable();
    } else {
      tokenAvailable();
      navigate('/login/');
    }
  };

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (
        (event.key === 'Enter' || event.code === 'NumpadEnter') &&
        isModalOpen
      ) {
        handleConfirm();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    if (isModalOpen && logoutButtonRef.current) {
      logoutButtonRef.current.focus();
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  const location = useLocation();

  useEffect(() => {
    if (
      location?.pathname?.includes('create') ||
      location?.pathname?.includes('update') ||
      location?.pathname?.includes('edit') ||
      location?.pathname?.includes('codewindow') ||
      location?.pathname?.includes('ledger-details/reports') ||
      location?.pathname?.includes('stock/detail/report/') ||
      location?.pathname?.includes('sales/gross-profit/reports/') ||
      location?.pathname?.includes('stock/ledger/report/') ||
      location?.pathname?.includes('transaction/bill-set-up/')
    ) {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [location?.pathname]);

  /**
   * Renders the profile dropdown content.
   * @returns {JSX.Element} - The profile dropdown content.
   */

  const handleFinancialYearChange = async () => {
    const response = await mutateFinancialYear({
      url: '/transaction/branch/switch-financial-year/',
    });
    if (response?.data?.length >= 1) {
      setFiscalYearOpen(true);
    } else {
      message.info('No Fiscal Year List Found');
    }
  };

  // const profileDropdownContent = () => (
  //   <>
  //     <div className="profile-dropdown">
  //       <div className="profile-info">
  //         <div>
  //           <Avatar
  //             src={
  //               user.companyImage
  //                 ? decodeBase64Image(user.companyImage)
  //                 : companyLogo
  //             }
  //             size="large"
  //             style={{
  //               height: 60,
  //               width: 60,
  //               boxShadow: '0 0 0 2px rgba(24, 151, 102, 0.76)',
  //               objectFit: 'cover',
  //             }}
  //           />
  //         </div>

  //         <div className="profile-details">
  //           <div className="company-name">
  //             {user.companyName || 'Company Name'}
  //           </div>
  //           <div className="license-number">Branch: {user.branchName}</div>
  //           <div className="license-number">
  //             License Number: {login.licenseNumber}
  //           </div>
  //         </div>
  //       </div>
  //       <hr />
  //       <div className="profile-contact">
  //         <div className="profile-contact-item">
  //           <strong>
  //             {user.username || 'Bishal Jwellers Private Limited'}
  //           </strong>
  //         </div>
  //         <div
  //           className="profile-contact-item-date tw-mt-2"
  //           style={{
  //             display: 'flex',
  //             alignItems: 'center',
  //             justifyContent: 'center',
  //             gap: 4,
  //           }}
  //         >
  //           F.Y:{' '}
  //           <p
  //             className="expiry-days !tw-mb-0 !tw-mt-0"
  //             style={{
  //               // marginBottom: 0,
  //               color: user?.isActive ? '' : '#ffc107',
  //             }}
  //           >
  //             {user.financialStartYear}{' '}
  //           </p>{' '}
  //           to{' '}
  //           <p
  //             className="expiry-days !tw-mb-0 !tw-mt-0"
  //             style={{
  //               // marginBottom: 0,
  //               color: user?.isActive ? '' : '#ffc107',
  //             }}
  //           >
  //             {user.financialEndYear}
  //           </p>
  //           {app?.isActive ? (
  //             <Tag color="green">Active</Tag>
  //           ) : (
  //             <Tag color="#ffc107">Inactive</Tag>
  //           )}
  //         </div>
  //       </div>
  //       <div className="profile-contact-second-details">
  //         <div className="profile-contact-second-details-item">
  //           {user.companyEmail || 'autonomous@example.com'}
  //         </div>
  //         <div className="profile-contact-second-details-item">
  //           {user.companyAddress || 'Dillibajar Kathmandu'}
  //         </div>
  //         <div className="profile-contact-second-details-item">
  //           {user.companyNumber || '(023) 456-789'}
  //         </div>
  //       </div>
  //       <div>
  //         {/* {getBranchList() && <AntButton color="blue">Switch Branch</AntButton>} */}
  //         <div className="tw-py-1 tw-flex tw-items-center tw-justify-center tw-gap-x-2">
  //           <AntButton
  //             color="blue"
  //             size="middle"
  //             onClick={handleFinancialYearChange}
  //             loading={isPending}
  //           >
  //             Switch Fiscal Year
  //           </AntButton>
  //           {app?.showAdminUrl && (
  //             <AntButton
  //               color="yellow"
  //               size="middle"
  //               onClick={() => {
  //                 confirm({
  //                   title: 'Are you sure you want to switch to admin?',
  //                   icon: (
  //                     <ExclamationCircleFilled
  //                       style={{ color: '#faad14', fontSize: 20 }}
  //                     />
  //                   ),
  //                   onOk: () => {
  //                     if (!token) {
  //                       tokenUnavailable();
  //                     } else if (app?.showAdminUrl) {
  //                       tokenAvailable();
  //                       navigate('/admin/login/');
  //                     }
  //                   },
  //                 });
  //               }}
  //               loading={isPending}
  //             >
  //               Switch to Admin
  //             </AntButton>
  //           )}
  //         </div>
  //       </div>
  //       <div className="profile-contact-second-details-item">
  //         {daysUntilExpiry !== null ? (
  //           <>
  //             Your license expires in{' '}
  //             <span className="expiry-days">{daysUntilExpiry}</span> days.
  //           </>
  //         ) : (
  //           'License expiry date not available'
  //         )}
  //       </div>
  //       <Divider />
  //       <Button
  //         block
  //         size="middle"
  //         icon={<LogoutOutlined />}
  //         onClick={() => setIsModalVisible(true)}
  //         className="submit-button"
  //       >
  //         Logout
  //       </Button>
  //     </div>
  //   </>
  // );

  /**
   * Opens the dashboard drawer with the specified type.
   * @param {string} type - The drawer type.
   */
  const openDrawer = (type, shortcut) => {
    setDrawerType(type);
    setDrawerVisible(true);
    setShortcuts(shortcut);
  };

  /**
   * Closes the dashboard drawer.
   */

  const closeDrawer = () => {
    setDrawerVisible(false);
    setDrawerType(null);
  };

  useEffect(() => {
    // Retrieve and decode user data from local storage
    const userData = decryptData(localStorage.getItem('userData'));
    const loginData = decryptData(localStorage.getItem('loginData'));
    localStorage.removeItem('otp');
    localStorage.removeItem('requirePasswordChange');
    if (userData) {
      setUser(userData);
    }
    if (loginData) {
      setLogin(loginData);
      setDaysUntilExpiry(userData?.licenseExpiryDays);
      // if (loginData.licenseExpiryDate) {
      //   const expiryDate = new Date(loginData.licenseExpiryDate);
      //   const today = new Date();
      //   const timeDiff = expiryDate - today;
      //   const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
      //   setDaysUntilExpiry(daysDiff);
      // }
    }
  }, []);

  useEffect(() => {
    if (app) {
      setUser(app);
    }
  }, [app]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      const { code, key } = e;
      if (code === 'KeyE' || key === 'e') {
        setCollapsed((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <Layout>
      <Sidebar collapsed={collapsed} colorBgContainer={colorBgContainer} />
      <Layout>
        {/* <Header
          style={{
            ...adminHeaderStyle,
            background: 'yellow',
            boxShadow: '1px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', // Adjusted to accommodate button placement
            padding: '0 20px',
            height: '40px',
            gap: '10px', // Optional for spacing
          }}
        >
          <p
            style={{
              display: 'inline-block',
              color: 'black',
              margin: 0,
              fontWeight: 500,
            }}
          >
          
            <Alert
              banner
              showIcon={false}
              message={
                <Marquee pauseOnHover gradient={false}>
                  This is a beta version and is under testing. If any errors
                  arise, please contact us.
                </Marquee>
              }
              style={{
                background: 'transparent',
              }}
            />
          </p>
          <button
            style={{
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
            }}
            className="submit-button"
            onClick={() => {
              setContactDrawerVisible(true);
            }}
          >
            Contact Us
          </button>
        </Header> */}

        {fiscalYearOpen && (
          <ModalFiscalYear
            fiscalYearOpen={fiscalYearOpen}
            setFiscalYearOpen={setFiscalYearOpen}
            fiscalYearData={FinancialData?.data || []}
          />
        )}

        <Header
          style={{
            ...adminHeaderStyle,
            background: '#189766c2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '1px',
          }}
        >
          <Button
            className="header-side-button"
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              fontSize: '14px',
              width: 40,
              height: 40,
              borderRadius: '50%',
              backgroundColor: isHovered ? '#addbb1' : 'transparent',
            }}
          />

          <GlobalModal
            isVisible={isModalVisible}
            onClose={() => setIsModalVisible(false)}
            onConfirm={handleConfirm}
            type="logout"
          />
          <div className="tw-flex tw-justify-end tw-items-center tw-gap-x-5">
            {/* <div
              className="tw-animate-pulse"
              style={{
                fontWeight: 600,
                fontSize: 18,
                letterSpacing: 3,
                display: 'flex',
              }}
            >
              <span style={{ color: '#FFA500' }}>H</span>
              <span style={{ color: '#FF4500' }}>a</span>
              <span style={{ color: '#FFD700' }}>p</span>
              <span style={{ color: '#FF6347' }}>p</span>
              <span style={{ color: '#daA520' }}>y</span>
              &nbsp;
              <span style={{ color: '#FF69B4' }}>D</span>
              <span style={{ color: '#FF8C00' }}>i</span>
              <span style={{ color: '#FFB6C1' }}>p</span>
              <span style={{ color: '#FFA07A' }}>a</span>
              <span style={{ color: '#FFD700' }}>w</span>
              <span style={{ color: '#FFA07A' }}>a</span>
              <span style={{ color: '#DAA520' }}>l</span>
              <span style={{ color: '#FF4500' }}>i</span>
            </div> */}

            <div className="tw-flex tw-items-center">
              <div>
                {!app?.isActive ? (
                  <Tag
                    color="#ffc107"
                    className="tw-animate-pulse tw-cursor-pointer tw-text-[0.75rem]"
                    onClick={() => {
                      handleFinancialYearChange();
                    }}
                  >
                    Inactive FY{' '}
                    {app?.financialStartYear?.slice(0, 4) ||
                      user?.financialStartYear?.slice(0, 4)}
                    /
                    {app?.financialEndYear?.slice(2, 4) ||
                      user?.financialEndYear?.slice(2, 4)}
                  </Tag>
                ) : (
                  <></>
                )}
              </div>
              <CalculatorApp />
            </div>
            <div>
              <DisplayNetworkStatus />
            </div>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
              }}
            >
              <div>
                <Dropdown
                  // popupRender={profileDropdownContent}
                  trigger={['click']}
                  popupRender={() => (
                    <div className="profile-dropdown">
                      <div className="profile-info">
                        <div>
                          <Avatar
                            src={
                              user?.companyImage
                                ? decodeBase64Image(user?.companyImage)
                                : companyLogo
                            }
                            size="large"
                            style={{
                              height: 60,
                              width: 60,
                              boxShadow: '0 0 0 2px rgba(24, 151, 102, 0.76)',
                              objectFit: 'cover',
                            }}
                          />
                        </div>

                        <div className="profile-details">
                          <div className="company-name">
                            {user.companyName || 'Company Name'}
                          </div>
                          <div className="license-number">
                            Branch: {user.branchName}
                          </div>
                          <div className="license-number">
                            License Number: {login.licenseNumber}
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div className="profile-contact">
                        <div className="profile-contact-item">
                          <strong>
                            {user.username || 'Bishal Jwellers Private Limited'}
                          </strong>
                        </div>
                        <div
                          className="profile-contact-item-date tw-mt-2"
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 4,
                          }}
                        >
                          F.Y:{' '}
                          <p
                            className="expiry-days !tw-mb-0 !tw-mt-0"
                            style={{
                              // marginBottom: 0,
                              color: user?.isActive ? '' : '#ffc107',
                            }}
                          >
                            {user.financialStartYear}{' '}
                          </p>{' '}
                          to{' '}
                          <p
                            className="expiry-days !tw-mb-0 !tw-mt-0"
                            style={{
                              // marginBottom: 0,
                              color: user?.isActive ? '' : '#ffc107',
                            }}
                          >
                            {user.financialEndYear}
                          </p>
                          {app?.isActive ? (
                            <Tag color="green">Active</Tag>
                          ) : (
                            <Tag color="#ffc107">Inactive</Tag>
                          )}
                        </div>
                      </div>
                      <div className="profile-contact-second-details">
                        <div className="profile-contact-second-details-item">
                          {user.companyEmail || 'autonomous@example.com'}
                        </div>
                        <div className="profile-contact-second-details-item">
                          {user.companyAddress || 'Dillibajar Kathmandu'}
                        </div>
                        <div className="profile-contact-second-details-item">
                          {user.companyNumber || '(023) 456-789'}
                        </div>
                      </div>
                      <div>
                        <div className="tw-py-1 tw-flex tw-items-center tw-justify-center tw-gap-x-2">
                          <AntButton
                            color="blue"
                            size="middle"
                            onClick={handleFinancialYearChange}
                            loading={isPending}
                          >
                            Switch Fiscal Year
                          </AntButton>
                          {app?.showAdminUrl && (
                            <AntButton
                              color="yellow"
                              size="middle"
                              onClick={() => {
                                confirm({
                                  title:
                                    'Are you sure you want to switch to admin?',
                                  icon: (
                                    <ExclamationCircleFilled
                                      style={{ color: '#faad14', fontSize: 20 }}
                                    />
                                  ),
                                  onOk: () => {
                                    if (!token) {
                                      tokenUnavailable();
                                    } else if (app?.showAdminUrl) {
                                      tokenAvailable();
                                      navigate('/admin/login/');
                                    }
                                  },
                                });
                              }}
                              loading={isPending}
                            >
                              Switch to Admin
                            </AntButton>
                          )}
                        </div>
                      </div>
                      <div className="profile-contact-second-details-item">
                        {daysUntilExpiry !== null ? (
                          <>
                            Your license expires in{' '}
                            <span className="expiry-days">
                              {daysUntilExpiry}
                            </span>{' '}
                            days.
                          </>
                        ) : (
                          'License expiry date not available'
                        )}
                      </div>
                      <Divider />
                      <AntButton
                        block
                        size="middle"
                        icon={<LogoutOutlined />}
                        onClick={() => setIsModalVisible(true)}
                        className="submit-button"
                      >
                        Logout
                      </AntButton>
                    </div>
                  )}
                  placement="bottom"
                  arrow={{
                    pointAtCenter: true,
                  }}
                >
                  <Avatar
                    src={
                      user?.companyImage
                        ? decodeBase64Image(user?.companyImage)
                        : companyLogo
                    }
                    size="medium"
                    style={{
                      background: 'white',
                      cursor: 'pointer',
                    }}
                  />
                </Dropdown>
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: '15px',
                  paddingRight: '30px',
                  fontSize: '20px',
                  cursor: 'pointer',
                }}
              >
                <img
                  className="header-icon"
                  src={question}
                  onClick={() => openDrawer('help')}
                />{' '}
                <img
                  className="header-icon"
                  src={setting}
                  onClick={() => openDrawer('settings')}
                />{' '}
                <img
                  className="header-icon"
                  src={keyboard}
                  onClick={() => openDrawer('shortcuts', true)}
                />{' '}
                <img className="header-icon" src={bell} />{' '}
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{
            ...adminContentStyle,
          }}
        >
          <main>
            <Outlet />
          </main>
        </Content>
        <Footer
          style={{
            backgroundColor: '#189766c2',
            color: 'black',
            textAlign: 'center',
            fontWeight: '500',
            fontSize: '1rem',
          }}
        >
          <AdminFooter />
        </Footer>
      </Layout>

      <DashboardDrawer
        drawerType={drawerType}
        visible={drawerVisible}
        onClose={closeDrawer}
        shortcuts={shortcuts}
        help={setHelp}
      />
      <ContactForSupport
        visible={contactDrawerVisible}
        onClose={() => setContactDrawerVisible(false)}
      />
    </Layout>
  );
};
export default DashboardLayout;
